function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import './Pagination.css';
import Button from '../../Buttons/Button/Button';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import DirectionalArrow from '../../Icons/DirectionalArrow/DirectionalArrow';
import DoubleDirectionalArrow from '../../Icons/DoubleDirectionalArrow/DoubleDirectionalArrow';
import IconButton from '../../Buttons/IconButton/IconButton';
import Tooltip from '../../Tips/Tooltip/Tooltip';
import en from './locales/Pagination.en.json';
import { SelectTypeahead } from '../../Inputs/SelectTypeahead/SelectTypeahead';
import compose from '../../utils/compose';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import uuid from '../../utils/uuid';
import { injectIntl } from 'react-intl';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import { formatI18n } from '../../I18n/I18n/I18n';
import { useContext } from 'react';
import ThemeContext from '../../ThemeContext';
var I18N_PREFIX = '@dm/components.pagination';
var messageKey = function messageKey(id) {
  return "".concat(I18N_PREFIX, ".").concat(id);
};
var SingleArrow = function SingleArrow(props) {
  var direction = props.direction;
  return /*#__PURE__*/React.createElement(DirectionalArrow, {
    className: "_dm-pagination__page-arrow",
    direction: direction
  });
};
var DoubleArrow = function DoubleArrow(props) {
  var direction = props.direction;
  return /*#__PURE__*/React.createElement(DoubleDirectionalArrow, {
    className: "_dm-pagination__page-arrow",
    direction: direction
  });
};
var ArrowButton = function ArrowButton(props) {
  var Arrow = props.Arrow,
    direction = props.direction,
    disabled = props.disabled,
    i18nKey = props.i18nKey,
    loading = props.loading,
    onClick = props.onClick;
  var tooltipKey = loading ? 'tooltip-loading-data' : "tooltip-".concat(i18nKey, "-").concat(disabled ? 'disabled' : 'enabled');
  return /*#__PURE__*/React.createElement("span", {
    className: "_dm-pagination__control _dm-pagination__control--".concat(direction, " _dm-pagination__control--button")
  }, /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: messageKey(tooltipKey)
  }, function (_ref) {
    var ref = _ref.ref,
      labelledby = _ref.labelledby,
      events = _ref.events;
    return /*#__PURE__*/React.createElement(IconButton, Object.assign({
      ref: ref,
      "aria-labelledby": labelledby,
      onClick: onClick,
      disabled: disabled
    }, events), /*#__PURE__*/React.createElement(Arrow, {
      direction: direction
    }));
  }));
};
var options = function options(inclusiveFirst, inclusiveLast) {
  var options = [];
  for (var index = inclusiveFirst; index <= inclusiveLast; index++) {
    options.push({
      value: index,
      label: index
    });
  }
  return options;
};
var PageSelect = function PageSelect(props) {
  var disabled = props.disabled,
    loading = props.loading,
    message = props.message,
    onGo = props.onGo,
    onSelectedChange = props.onSelectedChange,
    pages = props.pages,
    selectedPage = props.selectedPage;
  var theme = useContext(ThemeContext);
  var tooltipKey = loading ? 'tooltip-loading-data' : "tooltip-go-disabled-".concat(pages === 1 ? 'only' : 'invalid');
  return /*#__PURE__*/React.createElement("span", {
    className: '_dm-pagination__control _dm-pagination__page-select'
  }, /*#__PURE__*/React.createElement("span", null, message('text-page-input-prefix', {
    pages: pages
  }), " "), /*#__PURE__*/React.createElement("span", {
    className: "_dm-pagination__select _dm-pagination__select--".concat(theme)
  }, /*#__PURE__*/React.createElement(SelectTypeahead, {
    id: uuid(),
    "aria-label": message('label-select'),
    onChange: onSelectedChange,
    options: options(1, pages),
    placeholder: null,
    value: selectedPage
  })), ' ', /*#__PURE__*/React.createElement("span", null, message('text-page-input-suffix', {
    pages: pages
  }), " "), !disabled && /*#__PURE__*/React.createElement(Button, {
    className: "_dm-pagination__go _dm-pagination__control--button",
    disabled: false,
    onClick: onGo
  }, /*#__PURE__*/React.createElement(ButtonLabel, {
    i18nKey: messageKey('label-go')
  })), disabled && /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: messageKey(tooltipKey)
  }, function (_ref2) {
    var ref = _ref2.ref,
      labelledby = _ref2.labelledby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      "aria-labelledby": labelledby,
      className: "_dm-pagination__go _dm-pagination__control--button",
      disabled: true,
      ref: ref
    }, events), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: messageKey('label-go')
    }));
  }));
};
var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);
  function Pagination(props) {
    var _this;
    _classCallCheck(this, Pagination);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this, props));
    _this.message = function (id, values) {
      return _this.props.intl.formatMessage({
        id: messageKey(id)
      }, values);
    };
    _this.handleFirst = function () {
      _this.onPageChange(1);
    };
    _this.handlePrev = function () {
      _this.onPageChange(_this.props.page - 1);
    };
    _this.handleNext = function () {
      _this.onPageChange(_this.props.page + 1);
    };
    _this.handleLast = function () {
      _this.onPageChange(_this.props.pages);
    };
    _this.handleGo = function () {
      _this.props.onPageChange(_this.state.selectedPage);
    };
    _this.handleSelectedChange = function (e) {
      var value = e && e.value;
      var page = typeof value !== 'number' ? '' : Math.min(Math.max(value, 1), _this.props.pages);
      _this.setState({
        selectedPage: page
      });
    };
    _this.describebyId = uuid();
    _this.state = {
      selectedPage: props.page
    };
    return _this;
  }
  _createClass(Pagination, [{
    key: "onPageChange",
    value: function onPageChange(page) {
      this.props.onPageChange(page);
      this.setState({
        selectedPage: page
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        loading = _this$props.loading,
        page = _this$props.page,
        pages = _this$props.pages,
        className = _this$props.className,
        intl = _this$props.intl,
        statusMessage = _this$props.statusMessage,
        ariaLabel = _this$props['aria-label'];
      var label;
      if (ariaLabel) {
        label = formatI18n(intl, ariaLabel);
      } else {
        console.warn('You should add a `paginationLabel` to your Table. Please.');
      }
      var selectedPage = this.state.selectedPage;
      var canNext = page < pages && !loading;
      var canPrev = page > 1 && !loading;
      var canGo = selectedPage !== '' && pages > 1 && !loading;
      return /*#__PURE__*/React.createElement("nav", {
        role: "navigation",
        "aria-describedby": this.describebyId,
        "aria-label": label,
        className: "_dm-pagination ".concat(className)
      }, /*#__PURE__*/React.createElement("div", {
        id: this.describebyId,
        "aria-atomic": "true",
        "aria-live": "assertive",
        className: "_dm-pagination__status"
      }, statusMessage ? statusMessage : this.message('text-status', {
        page: page,
        pages: pages
      })), /*#__PURE__*/React.createElement("div", {
        className: "_dm-pagination__controls"
      }, /*#__PURE__*/React.createElement(ArrowButton, {
        Arrow: DoubleArrow,
        direction: "left",
        disabled: !canPrev,
        i18nKey: "first",
        loading: loading,
        onClick: this.handleFirst
      }), /*#__PURE__*/React.createElement(ArrowButton, {
        Arrow: SingleArrow,
        direction: "left",
        disabled: !canPrev,
        i18nKey: "prev",
        loading: loading,
        onClick: this.handlePrev
      }), /*#__PURE__*/React.createElement(PageSelect, {
        disabled: !canGo,
        loading: loading,
        message: this.message,
        onGo: this.handleGo,
        onSelectedChange: this.handleSelectedChange,
        pages: pages,
        selectedPage: selectedPage
      }), /*#__PURE__*/React.createElement(ArrowButton, {
        Arrow: SingleArrow,
        direction: "right",
        disabled: !canNext,
        i18nKey: "next",
        loading: loading,
        onClick: this.handleNext
      }), /*#__PURE__*/React.createElement(ArrowButton, {
        Arrow: DoubleArrow,
        direction: "right",
        disabled: !canNext,
        i18nKey: "last",
        loading: loading,
        onClick: this.handleLast
      })));
    }
  }]);
  return Pagination;
}(React.Component);
var messages = normalizeLocaleData(en, I18N_PREFIX);
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(Pagination);
enhanced.displayName = 'Enhanced(Pagination)';
export default enhanced;